import { hasSsrFailed } from "./ssrFailure";
import ServerResponseContext from "./ServerResponseContext";

interface SetHttpStatusCodeProps {
  httpStatus: number;
}

function SetHttpStatusCode({ httpStatus }: SetHttpStatusCodeProps) {
  return (
    <ServerResponseContext.Consumer>
      {(response) => {
        if (response && !hasSsrFailed(response)) {
          response.statusCode = httpStatus;
          return null;
        }

        return null;
      }}
    </ServerResponseContext.Consumer>
  );
}

export default SetHttpStatusCode;
